import { render } from "./ScrollToTopArrow.vue?vue&type=template&id=1fb836d4&scoped=true&ts=true"
import script from "./ScrollToTopArrow.vue?vue&type=script&lang=ts"
export * from "./ScrollToTopArrow.vue?vue&type=script&lang=ts"

import "./ScrollToTopArrow.vue?vue&type=style&index=0&id=1fb836d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb836d4"]])

export default __exports__